import {
  Icon,
  useTheme,
  Text,
  HStack,
  Box,
  Tooltip,
  VStack,
  IconName,
} from '@wegroup/design-system';
import React, { useContext } from 'react';
import convertKeyToIconName from '../../../../../common/src/utils/convertKeyToIconName';
import { ThemeContext } from 'styled-components';
import { toEuro } from '../../../utils/stringUtils';
interface Props {
  type: string;
  active?: boolean;
  onClick?: () => void;
  isSmall?: boolean;
  disabled?: boolean;
  insuranceType?: string;
  description?: string;
  price?: number;
}
const OfferOptionButton: React.FC<React.PropsWithChildren<Props>> = ({
  type,
  active,
  onClick = () => null,
  isSmall,
  children,
  disabled,
  insuranceType,
  description,
  price,
}) => {
  const { colors } = useTheme();
  const theme = useContext(ThemeContext);

  return (
    <Tooltip
      label={
        <TooltipContent
          title={children}
          description={description}
          price={price}
        />
      }
      isDisabled={!children && !description && !price}
    >
      <HStack
        borderRadius="full"
        py="2"
        px="4"
        spacing="2"
        h="8"
        w={isSmall ? '8' : 'unset'}
        justify="center"
        onClick={() => !disabled && onClick()}
        cursor={disabled ? 'default' : 'pointer'}
        bg={
          active
            ? theme['isImmo']
              ? theme.secondary[500]
              : 'primary.50'
            : 'gray.strokeAndBg'
        }
        color={
          active ? (theme['isImmo'] ? 'white' : 'primary.500') : 'gray.300'
        }
      >
        <Box
          sx={{
            '>svg': {
              height: '5',
              width: '5',
            },
          }}
        >
          <Icon
            name={
              insuranceType
                ? convertKeyToIconName(type, insuranceType)
                : (type as IconName)
            }
            color={
              active
                ? theme['isImmo']
                  ? colors.white
                  : colors.primary[500]
                : colors.text.gray
            }
          />
        </Box>

        {!isSmall && <Text textStyle="smallBody">{children}</Text>}
      </HStack>
    </Tooltip>
  );
};

export const TooltipContent: React.FC<
  React.PropsWithChildren<{
    title: React.ReactNode;
    description?: string;
    price?: number;
  }>
> = ({ title, description, price }) => {
  return (
    <VStack align="flex-start">
      <Text textStyle="smallBodyBold">
        {title}
        {price != null && ` - ${toEuro(price)}`}
      </Text>
      {description && <Text textStyle="smallBody">{description}</Text>}
    </VStack>
  );
};

export default OfferOptionButton;
